<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
        <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs" v-on="on" style="margin-right: -40px">
              {{ $t("natural-hazards") }}
              <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
            </div>
          </template>
          <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
        </v-tooltip>
        <div v-else>
          {{ $t("natural-hazards") }}
          <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <TooltipTR section="section700" field="HAZ_FAL" :label="$t('fall-hazard')">
                <div>
                  {{ $t("fall-hazard") }}
                  <span v-if="plotItem.HAZ_FAL_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.HAZ_FAL }}
                </div>
              </TooltipTR>
              <TooltipTR section="section700" field="HAZ_LAV" :label="$t('avalanche-hazard')">
                <div>
                  {{ $t("avalanche-hazard") }}
                  <span v-if="plotItem.HAZ_LAV_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.HAZ_LAV }}
                </div>
              </TooltipTR>
              <TooltipTR section="section700" field="HAZ_SLI" :label="$t('slip-hazard')">
                <div>
                  {{ $t("slip-hazard") }}
                  <span v-if="plotItem.HAZ_SLI_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>
                  <b>{{ plotItem.HAZ_SLI }}</b>
                </div>
              </TooltipTR>
              <TooltipTR section="section700" field="HAZ_WAT" :label="$t('water-hazard')">
                <div>
                  {{ $t("water-hazard") }}
                  <span v-if="plotItem.HAZ_WAT_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>
                  <b>{{ plotItem.HAZ_WAT }}</b>
                </div>
              </TooltipTR>
              <TooltipTR section="section700" field="HAZ_DOL" :label="$t('sinkhole-hazard')">
                <div>
                  {{ $t("sinkhole-hazard") }}
                  <span v-if="plotItem.HAZ_DOL_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.HAZ_DOL }}
                </div>
              </TooltipTR>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  contentJson: any = {}
  language

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.loadTooltip()
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section700")) || {}
  }

  get hasAtLeastOneWarning() {
    if (this.plotItem.HAZ_FAL_LABEL == "Y" || this.plotItem.HAZ_LAV_LABEL == "Y" || this.plotItem.HAZ_SLI_LABEL == "Y" || this.plotItem.HAZ_WAT_LABEL == "Y" || this.plotItem.HAZ_DOL_LABEL == "Y") {
      return true
    }
    return false
  }

}
</script>
